import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconToolsRightTopSizeS from './IconToolsRightTop_size_s';

const props: CreateIconArguments = {
  l: IconToolsRightTopSizeS,
  m: IconToolsRightTopSizeS,
  s: IconToolsRightTopSizeS,
  xs: IconToolsRightTopSizeS,
  name: 'IconToolsRightTop',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
